import React from "react";
import { styled } from "@mui/material/styles";

const ChipContainer = styled("div")(
  ({
    theme,
    backgroundColor,
    fontSize,
    color,
    hoverBackgroundColor,
    border,
  }) => ({
    display: "inline-flex",
    alignItems: "center",
    padding: "2px 10px",
    borderRadius: "16px",
    backgroundColor: backgroundColor || theme.palette.primary.main, // Default to theme color if not provided
    color: color || theme.palette.text.main, // Default to theme contrast color if not provided
    fontSize: fontSize,
    fontWeight: 500,
    cursor: "pointer",
    border: border || `1px solid ${theme.palette.primary.main}`,
    "&:hover": {
      backgroundColor: hoverBackgroundColor || theme.palette.primary.focus, // Default to theme dark color if not provided
    },
  })
);

const Label = styled("span")({
  margin: "0 4px",
});

const Chip = ({
  label = "Default Label", // Default value for label
  backgroundColor,
  color,
  fontSize,
  hoverBackgroundColor,
  ...props
}) => {
  return (
    <ChipContainer
      backgroundColor={backgroundColor}
      color={color}
      hoverBackgroundColor={hoverBackgroundColor}
      fontSize={fontSize}
      {...props}
    >
      <Label>{label}</Label>
    </ChipContainer>
  );
};

export default Chip;
